import { PriceDisplay, typographyV2 } from '@toggle/design-system';
import styled, { css } from 'styled-components';

export const DateSpan = styled.span<{ $isCardView?: boolean }>`
  ${typographyV2.bodyXs}
  color: var(--text-soft);
  margin-right: ${({ $isCardView }) => ($isCardView ? 0 : '12px')};
`;

export const StyledPriceDisplay = styled(PriceDisplay)<{
  $isCardView?: boolean;
}>`
  ${PriceDisplay.Styled.Price} {
    ${({ $isCardView }) =>
      $isCardView ? typographyV2.bodySm : typographyV2.titleLg}
  }

  ${PriceDisplay.Styled.OutsideHoursTag} {
    margin-right: ${({ $isCardView }) => ($isCardView ? 0 : '12px')};
  }

  ${PriceDisplay.Styled.Currency} {
    ${typographyV2.bodyXXs};
  }

  ${PriceDisplay.Styled.PriceChangeContainer} {
    ${({ $isCardView }) =>
      $isCardView ? typographyV2.bodySm : typographyV2.bodySm}
  }

  ${({ $isCardView }) =>
    $isCardView &&
    css`
      && {
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 8px;
      }

      ${PriceDisplay.Styled.PriceChangeContainer} {
        span:last-child {
          display: none;
        }
      }
    `}
`;
